import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import helpersNumbers from "../../../../helpers/numbers";
import TitleBar from "../../../partials/content/TitleBar";
import UsersList from "../../user/ListUserCustomerCoWorker";
import ButtonDisable from "../../../partials/other/ButtonDisable";

const typeTransaction = {};

export default function AddTransaction() {
  const [amount, setAmount] = useState(250000);

  const generateOptionTagUsers = () => {
    return UsersList.map((user) => {
      return (
        <option value={user.id}>
          {`
          شماره کاربر : ${helpersNumbers.toPersianNum(user.id)}
          |
           ${user.first_name} ${user.last_name}
          |  موجودی کاربر : 
          ${helpersNumbers.toPersianNum(
            helpersNumbers.toFormatFinanceNumber(user.wallet)
          )} تومان`}
        </option>
      );
    });
  };

  const inputAmountChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }

    changeAmount(parseInt(number));
  };

  const inputAmountBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const changeAmount = (number) => {
    setAmount(number);
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="تراکنش جدید" />

        <section className="content pt-5">
          <div className="card" id="add-transaction">
            <div className="card-body">
              <div className="container">
                <div className="text-left">
                  <Link className="btn btn-primary" to="/finance/transaction">
                    بازگشت
                    <span className="pr-2">
                      <i class="fas fa-arrow-left"></i>
                    </span>
                  </Link>
                </div>
                <div className="row justify-content-center">
                  <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                    <form>
                      <div class="form-group">
                        <label>مبلغ (تومان)</label>
                        <input
                          type="text"
                          id="amount"
                          class="form-control number-finance"
                          value={helpersNumbers.toPersianNum(
                            helpersNumbers.toFormatFinanceNumber(amount)
                          )}
                          onChange={inputAmountChangeHandler}
                          onBeforeInput={inputAmountBeforeInputHandler}
                          dir="ltr"
                        />
                      </div>
                      <div class="form-group">
                        <label>کاربر</label>
                        <select class="form-control" id="user">
                          <option value={0}>انتخاب کنید</option>
                          {generateOptionTagUsers()}
                        </select>
                      </div>
                      <div class="form-group">
                        <label>نوع تراکنش</label>
                        <select class="form-control" id="operate">
                          <option value={0}>انتخاب کنید</option>
                          <option value="1">اضافه کردن</option>
                          <option value="2">کسر کردن</option>
                        </select>
                      </div>
                      <div class="form-group text-center">
                        <ButtonDisable
                          buttonTagHtml={
                            <span className="btn btn-success opacity-50">
                              <span className="pl-2">
                                <i className="fa fa-credit-card"></i>
                              </span>
                              <span>اعمال</span>
                            </span>
                          }
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
